import React, { useEffect } from "react";
import Box from "@material-ui/core/Box";
import CheckboxGroup from "../common/CheckboxGroup";
import { A11yContext } from "./A11yContext";
import {
  BUILDING_COLORS,
  UNDER_CONSTRUCTION,
  APPROVED,
  APPLIED
} from "./constants";

// import { useTheme } from "@material-ui/core/styles";
// import useMediaQuery from "@material-ui/core/useMediaQuery";

export default React.memo(function StatusFilter({
  value,
  setValue,
  setFilters
}) {
  const { a11yMode } = React.useContext(A11yContext);
  const statusOptions = [
    {
      value: APPLIED,
      label: "Applied for Permit",
      color: BUILDING_COLORS.main[APPLIED]
    },
    {
      value: APPROVED,
      label: "Permit Approved",
      color: BUILDING_COLORS.main[APPROVED]
    },
    {
      value: UNDER_CONSTRUCTION,
      label: "Under Construction",
      color: BUILDING_COLORS.main[UNDER_CONSTRUCTION]
    }
  ];
  const accessibleStatusOptions = [
    {
      value: APPLIED,
      label: "Applied for Permit",
      color: BUILDING_COLORS.a11y[APPLIED]
    },
    {
      value: APPROVED,
      label: "Permit Approved",
      color: BUILDING_COLORS.a11y[APPROVED]
    },
    {
      value: UNDER_CONSTRUCTION,
      label: "Under Construction",
      color: BUILDING_COLORS.a11y[UNDER_CONSTRUCTION]
    }
  ];

  const options = a11yMode ? accessibleStatusOptions : statusOptions;

  /**
   * Handle status filter value change
   */
  const handleSetStatusFilter = optionValue =>
    setValue(value =>
      value.includes(optionValue)
        ? value.filter(v => v !== optionValue)
        : [...value, optionValue]
    );

  /**
   * Listen for changes to the status and update filters accordingly
   */
  useEffect(() => {
    /**
     * Set filters so the parent can filter both
     */
    const status = { key: "status", condition: "in", value };
    setFilters(filters => {
      const statusIndex = filters.findIndex(f => f.key === "status");
      const nextFilters = [...filters];
      if (statusIndex === -1) {
        nextFilters.push(status);
      } else {
        nextFilters[statusIndex] = status;
      }

      return nextFilters;
    });
    // setFilters(s => ({ ...s, status }));
    // eslint-disable-next-line
  }, [value, setFilters]);

  /**
   * Show/hide constructed depending on the value
   */

  return (
    <Box p={{ xs: 0, md: 1 }} pb={{ xs: 8, md: 2 }}>
      <Box
        fontSize={20}
        fontFamily="Gotham, Arial, Helvetica, sans-serif"
        textAlign="center"
        mt={{ xs: 0, md: 1 }}
        mb={{ xs: 1, md: 2 }}
        position="relative"
        zIndex={1}
        color="grey400"
      >
        Filter Buildings
      </Box>
      <CheckboxGroup
        options={options}
        value={value}
        onChange={handleSetStatusFilter}
        // label="By status"
      />
    </Box>
  );
});
